import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeData";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <h1 className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            黑料网红
          </span>
          <span className="hidden font-label text-[11px] tracking-[0.25em] text-foreground-500 sm:inline">
            BLACKGOSSIP
          </span>
        </h1>

        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap font-label text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-notification-3-line" />
            追更订阅
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 font-label text-sm text-foreground-700 last:border-b-0"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50"
            >
              <i className="ri-notification-3-line" />
              追更订阅
            </a>
          </div>
        </nav>
      ) : null}
    </header>
  );
}